var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcPostresGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.61,46,43.5,32.58a13.6,13.6,0,0,0-6.29-9.48,7.32,7.32,0,0,1-14.42,0,13.62,13.62,0,0,0-6.29,9.48L14.39,46a4.27,4.27,0,0,0,4.21,4.94H41.39A4.27,4.27,0,0,0,45.61,46Zm-3.13,1.59a1.42,1.42,0,0,1-1.08.5H18.61a1.42,1.42,0,0,1-1.09-.5,1.41,1.41,0,0,1-.32-1.15L19.32,33a10.64,10.64,0,0,1,.44-1.79,13.27,13.27,0,0,1,6.8,1.54c3.88,2,4.77,7.27,9.09,9.13a8.12,8.12,0,0,0,6.49.31l.66,4.2a1.41,1.41,0,0,1-.32,1.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.77,11.94A8.35,8.35,0,0,1,28,17.07a5.22,5.22,0,1,0,2.9-.34,11.06,11.06,0,0,0-10-7.63,1.4,1.4,0,0,0-1.48,1.36,1.42,1.42,0,0,0,1.37,1.48Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcPostresGreen);
export default __webpack_public_path__ + "static/media/DC__Postres_green.7b3e4f40c902123db753fa3a4b90d242.svg";
export { ForwardRef as ReactComponent };